import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LoginForm } from "@/components/auth/LoginForm";
import { SignUpForm } from "@/components/auth/SignUpForm";
import { SocialAuth } from "./SocialAuth";
import { AuthDialogProps } from '@/types';

export const AuthDialog: React.FC<AuthDialogProps> = ({ 
  isOpen, 
  onClose, 
  defaultTab = "login" 
}) => {
  const [activeTab, setActiveTab] = React.useState(defaultTab);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[400px] p-4">
        <DialogHeader className="p-0">
          <DialogTitle className="text-lg font-semibold text-center mb-2">
            {activeTab === 'login' ? 'Welcome Back' : 'Join SurfSnap'}
          </DialogTitle>
        </DialogHeader>

        {/* Social Authentication with reduced spacing */}
        <div className="mb-3">
          <SocialAuth mode={activeTab === 'login' ? 'login' : 'signup'} />
        </div>

        {/* Email Authentication with compact styling */}
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-2 h-8 mb-2">
            <TabsTrigger value="login" className="text-sm">Login</TabsTrigger>
            <TabsTrigger value="signup" className="text-sm">Sign Up</TabsTrigger>
          </TabsList>

          <TabsContent value="login" className="mt-0 space-y-2">
            <LoginForm onSuccess={onClose} />
          </TabsContent>

          <TabsContent value="signup" className="mt-0 space-y-2">
            <SignUpForm onSuccess={onClose} />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};